import type { UI } from '@/v2/types';

import { PackageOption as PackageOptionType } from '@shared/v2/utils/getPackageOptions';

import RoomOptionDetails from '@/v2/components/pages/PackageView/components/RoomOptionDetails';

interface SelectedRoomPanelProps {
  upgradeOffer?: UI.RoomOptionOffer;
  selectedPackageOption?: PackageOptionType;
  selectedRoomOption: UI.RoomOption;
}

const SelectedRoomPanel = ({
  selectedRoomOption,
  selectedPackageOption,
}: SelectedRoomPanelProps) => {
  const { matchingOffer, roomType } = selectedRoomOption;
  const { title } = selectedPackageOption || {};

  if (!matchingOffer) {
    return null;
  }

  return (
    <RoomOptionDetails
      packageName={title}
      offer={matchingOffer}
      roomName={roomType.name}
    />
  );
};

export default SelectedRoomPanel;
